// extracted by mini-css-extract-plugin
export default {"wrapper":"OT-z","firstToReview":"PT-z","productCards":"QT-z","productCard":"RT-z","stars":"ST-z","hidden":"TT-z"};